import { REACT_QUERY_KEYS, bridgeRequest } from 'common'
import { IRequestTermsResponse } from 'pages'
import { TEntity } from 'contexts/app-context/types'

import { useQuery } from '@tanstack/react-query'

import { requestTermsPendingAcceptanceBody } from '../utils'

const REQUEST_TERMS_PENDING_ACCEPTANCE_ENDPOINT = {
  id: 'useRequestTermsPendingAcceptance',
  url: '/app-pf/central-privacidades/v1/termos/aceite-pendente',
  method: 'POST',
  isActive: true,
  headers: { 'x-inter-verification-type': 'GLOBAL_ACCOUNT_ENTRY' },
}

export const useRequestTermsPendingAcceptance = (org?: TEntity) => {
  const { data, status, isError, isLoading } = useQuery({
    queryKey: [REACT_QUERY_KEYS.PRIVACY_POLICY_ACCEPTANCE_TERMS, requestTermsPendingAcceptanceBody],
    queryFn: () =>
      bridgeRequest<IRequestTermsResponse>({
        endpoint: REQUEST_TERMS_PENDING_ACCEPTANCE_ENDPOINT,
        body: requestTermsPendingAcceptanceBody,
        returnAllResponse: false,
        isUSBranch: org === 'US_BRANCH',
      }),
    staleTime: 1000 * 60 * 10, // 10 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
  })

  const terms = data ?? []

  return { terms, status, isError, isLoading }
}
